export default __webpack_public_path__ + "static/media/mobilefinance.d1db8fa4.svg";